/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Refs_P1Inputs */

const en_wc_tut_refs_p1 = /** @type {(inputs: Wc_Tut_Refs_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once your headings use Heading styles, References → Table of Contents builds a TOC with page numbers. Update it after editing.`)
};

/**
* | output |
* | --- |
* | "Once your headings use Heading styles, References → Table of Contents builds a TOC with page numbers. Update it after editing." |
*
* @param {Wc_Tut_Refs_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_refs_p1 = /** @type {((inputs?: Wc_Tut_Refs_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Refs_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_refs_p1(inputs)
});
export { wc_tut_refs_p1 as "wc.tut.refs.p1" }